import React, {Component} from 'react';
import {Col, Form, FormGroup, FormControl, ControlLabel} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import Validator from "../../../../../utilities/Validator";

export default class PokazTraseNaMapieContainerEdycjaKoordynatowGPS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            przystanek: null
        };
        this.edytujGps = this.edytujGps.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.przystanek)) {
            this.setState({
                przystanek: this.props.przystanek
            })
        }
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.przystanek)) {
            this.setState({
                przystanek: nextprops.przystanek
            })
        }
    }

    edytujGps(val, key) {
        let obj = this.state.przystanek
        obj[key] = val.target.value
        this.setState({przystanek:obj})
    }

    onClickZapisz() {
        let poprawne = true;

        if (Boolean(this.state.przystanek.szGps)) {
            if (!Validator.validateIntOrDouble(this.state.przystanek.szGps) || !Validator.validateSzerokoscDlugoscWysokoscGeo(this.state.przystanek.szGps, 'sz')) {
                poprawne = false;
            }
        }

        if (Boolean(this.state.przystanek.dlGps)) {
            if ((!Validator.validateIntOrDouble(this.state.przystanek.dlGps) || !Validator.validateSzerokoscDlugoscWysokoscGeo(this.state.przystanek.dlGps, 'dl'))) {
                poprawne = false;
            }
        }

        if(poprawne){
            this.props.handleZapiszPrzystanek(this.state.przystanek)
        }
        else{
            alert('Podano niepoprawne wartości!')
        }

    }

    render() {
        if (Boolean(this.state.przystanek))
            return (
                <div>
                    <fieldset>
                        <div className={'fieldset-label'}>Edytuj koordynaty GPS</div>
                        <Form horizontal={true}>
                            <FormGroup>
                                <Col xs={12}>
                                    <h4>
                                        <span className={'label label-ebus-primary'}
                                              style={{marginRight: '5px', fontSize: 'inherit'}}>{this.state.przystanek.nazMi}</span>
                                        {this.state.przystanek.nazPr}
                                    </h4>
                                </Col>
                                <Col xs={2}>
                                    <ControlLabel>Szerokość geo.</ControlLabel>
                                    <FormControl type={'number'} defaultValue={this.state.przystanek.szGps}
                                                 onChange={(e) => this.edytujGps(e, 'szGps')}/>
                                </Col>
                                <Col xs={2}>
                                    <ControlLabel>Długość geo.</ControlLabel>
                                    <FormControl type={'number'} defaultValue={this.state.przystanek.dlGps}
                                                 onChange={(e) => this.edytujGps(e, 'dlGps')}/>
                                </Col>
                                <Col xs={2}>
                                    <div className={'add-label-margin'}></div>
                                    <TopButtonCancel onClick={() => {
                                        this.props.handleClickAnuluj()
                                    }} text={'Anuluj'}/>
                                    <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </fieldset>
                </div>

            );
        else return ''
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/trasy/googleMapComponents/PokazTraseNaMapieContainerEdycjaKoordynatowGPS.js